import { clsx } from 'clsx';
import { InfoOutlined as InfoOutlinedIcon } from '@material-ui/icons';

import useStyles from './styles';

import type { BaseProps } from '../../../../../interfaces';

export function BaseCustomAlert({ classes, text, hasIcon = true }: Props) {
  const _classes = useStyles();
  return (
    <div className={clsx(_classes.root, classes?.root)}>
      {hasIcon && <InfoOutlinedIcon className={_classes.icon} />}
      <div
        className={clsx(_classes.content, classes?.content)}
        dangerouslySetInnerHTML={{
          __html: text || '',
        }}
      />
    </div>
  );
}

interface Props extends BaseProps {
  text?: string | null;
  hasIcon?: boolean;
}
